export default __webpack_public_path__ + "img/icon-plus.fd2d1b6d.svg";